




















import { Component, Watch } from 'vue-property-decorator';
import * as api from '@/api';
import { PaginationMixin } from '@/utils/mixin';
import SetOncallRule from './components/set-oncall-rule.vue';
import OncallByPerson from './components/oncall/oncall-by-person.vue';
import OncallByGroup from './components/oncall/oncall-by-group.vue';

type PlanType = 'PERSON' | 'GROUP' | '';

const getPlanType = (mode: string): PlanType => {
    switch (mode) {
        case 'MULTI_ONLINE':
        case 'SINGLE_TURN':
            return 'PERSON';
        case 'GROUP_TURN':
        case 'GROUP_TIME_TURN':
            return 'GROUP';
        default:
            return '';
    }
};

/**
 * rg成员列表
 *
 * @author zhouchangshun
 * @date 01/11/2019
 */
@Component({
    components: {
        SetOncallRule,
        OncallByPerson,
        OncallByGroup
    }
})
export default class Oncall extends PaginationMixin {
    rgId: number | null = null;
    planType: PlanType = '';

    dutyMode: string = '';
    ruleCycle: string = '';
    ruleStart: number | null = null;

    created() {
        this.rgId = Number(this.$route.query.rgId);
        if (!this.rgId) {
            console.error('invalid rgId query string');
            return;
        }
        this.getOncallRule();
    }

    refreshMode(val) {
        this.dutyMode = val;
        this.getOncallRule();
    }

    async getOncallRule() {
        const res = await api.rgApi.getOncallRule(this.rgId);
        const { code, data } = res;
        if (code === 200) {
            this.dutyMode = data.mode;
            this.ruleCycle = data.ruleCycle;
            this.ruleStart = this.handleRuleStart(data.ruleStart || '');
        } else {
            console.error(code, res.message);
        }
    }

    setDutyMode(val) {
        this.dutyMode = val;
    }

    handleRuleStart(str) {
        const ruleArr = str.split('-');
        let timePoint = 0;
        if (ruleArr.length > 1) {
            timePoint = this.ruleCycle === 'week' ? parseInt(ruleArr[0], 10) : parseInt(ruleArr[1], 10) + 1;
        }
        return timePoint;
    }

    @Watch('dutyMode')
    setupPlanType(val) {
        this.planType = getPlanType(val);
    }

    get _planType(): PlanType {
        switch (this.dutyMode) {
            case 'MULTI_ONLINE':
            case 'SINGLE_ONLINE':
                return 'PERSON';
            case 'GROUP_TURN':
            case 'GROUP_TIME_TURN':
                return 'GROUP';
            default:
                return '';
        }
    }
}
